//Converts all the keys of a
export const objectKeysToLowerCase = (obj: any) =>
  Object.keys(obj).reduce((acc, key) => {
    acc[key.toLowerCase()] = obj[key];
    return acc;
  }, {});
